import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { trackButton } from "@/lib/analytics";

export const CTABand = ({
  title = "Ready to see Hewto.ai on your documents?",
  subtitle = "Book a personalized demo and watch us process your HCFA, UB-04, and dental claims live.",
}) => {
  const navigate = useNavigate();
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-slate-950 px-8 py-16 sm:px-16">
          <div className="absolute inset-0 bg-grid-dark opacity-40" aria-hidden="true" />
          <div
            className="absolute -right-20 -top-24 h-72 w-72 rounded-full bg-brand/30 blur-3xl"
            aria-hidden="true"
          />
          <div className="relative max-w-2xl">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">{title}</h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-300">{subtitle}</p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Button
                data-testid="cta-book-demo-btn"
                onClick={() => {
                  trackButton("Book Demo", { source: "cta_band" });
                  navigate("/contact-sales");
                }}
                className="group rounded-full bg-brand px-6 py-6 text-base font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-brand-600"
              >
                Book a Demo
                <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export const PageHero = ({ eyebrow, title, subtitle, children }) => (
  <section className="relative overflow-hidden border-b border-slate-100 bg-slate-50">
    <div className="absolute inset-0 bg-grid opacity-60" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal>
        {eyebrow && (
          <span
            data-testid="page-eyebrow"
            className="inline-block rounded-full bg-brand-50 px-4 py-1.5 text-sm font-semibold text-brand-600"
          >
            {eyebrow}
          </span>
        )}
        <h1 className="mt-5 max-w-3xl text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-600">{subtitle}</p>
        )}
        {children}
      </Reveal>
    </div>
  </section>
);

export default CTABand;
